import React, { useContext, useEffect, useMemo } from "react";
import DataGrid from "components/Table/DataGrid"; //
import { useDispatch, useSelector } from "react-redux";
import { getChangeOrders } from "selectors/changeOrderSelectors";
import {
  deleteChangeOrderAction,
  fetchChangeOrdersAction,
} from "actions/change_orderActions";
import {
  DeleteOutlined,
  EditOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import BurgerMenu from "components/Menu/BurgerMenu";
import { getMomentDate } from "core/utils/appUtils";
import HiddenOn from "components/Wrappers/HiddenOn";
import { isHomeOwner, isProjectLimitedView } from "core/utils/roleUtils";
import AppRoleContext from "context/AppRoleContext";
import { get } from "lodash";

const ListChangeOrders = (props) => {
  const { onRowClick, propertyId, projectId, projectData } = props;
  const appRoleDetails = useContext(AppRoleContext);

  const dispatch = useDispatch();
  const { changeOrdersList, totalCount } = useSelector(getChangeOrders);

  const isStatusNew = (changeOrderData) => {
    const currentStatus = get(
      changeOrderData,
      "changeOrderStatusReqResp.statusName",
      ""
    );
    return currentStatus.toLowerCase() === "new";
  };
  const columns = useMemo(
    () => [
      {
        field: "changeOrderNumber",
        headerName: "CO #",
        flex: 0.7,
        minWidth: 110,
        sortable: false,
      },
      {
        field: "changeOrderDate",
        headerName: "Date",
        flex: 0.8,
        valueGetter: (p) => getMomentDate(p),
        minWidth: 110,
      },
      {
        field: "clientName",
        headerName: "Client",
        flex: 1,
        minWidth: 140,
        sortable: false,
      },
      {
        field: "originalContractCost",
        sortable: false,
        headerName: "Original ($)",
        flex: 0.9,
        minWidth: 120,
        valueFormatter: (value) => (value != null ? value.toFixed(2) : "0.00"),
      },
      {
        field: "estimatedChangeCost",
        headerName: "Change ($)",
        sortable: false,
        flex: 0.9,
        minWidth: 120,
        valueFormatter: (value) => (value != null ? value.toFixed(2) : "0.00"),
      },
      {
        field: "revisedCompletionDate",
        headerName: "Revised Completion",
        flex: 1,
        minWidth: 150,
        valueGetter: (p) => getMomentDate(p),
      },
      {
        field: "statusName",
        headerName: "Status",
        flex: 0.8,
        minWidth: 110,
        sortable: false,
        renderCell: ({ row }) => (
          <div className="change-order-status-cell">
            <span>{row?.changeOrderStatusReqResp?.statusName}</span>
          </div>
        ),
      },
      {
        field: "actions",
        type: "actions",
        flex: 0.8,
        align: "right",
        getActions: (params) => [
          <BurgerMenu key={params.id}>
            <MenuItem
              key={`view-${params.id}`}
              onClick={() => onRowClick?.(params.row, "view")}
            >
              <p className="m-0">View Order</p>
              <VisibilityOutlined />
            </MenuItem>
            <HiddenOn
              isHidden={
                isProjectLimitedView(
                  appRoleDetails,
                  projectData?.projUserRole
                ) || isHomeOwner(appRoleDetails)
              }
            >
              {isStatusNew(params.row) && (
                <MenuItem
                  key={`edit-${params.id}`}
                  onClick={() => onRowClick?.(params.row, "edit")}
                >
                  <p className="m-0">Edit Order</p>
                  <EditOutlined />
                </MenuItem>
              )}

              <MenuItem
                key={`delete-${params.id}`}
                onClick={() => {
                  dispatch(
                    deleteChangeOrderAction(params.row.changeOrderId, () => {
                      fetchChangeOrders();
                    })
                  );
                }}
              >
                <p className="m-0">Delete Order</p>
                <DeleteOutlined />
              </MenuItem>
            </HiddenOn>
          </BurgerMenu>,
        ],
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, onRowClick]
  );
  const [pageModel, setPageModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const fetchChangeOrders = React.useCallback(() => {
    dispatch(
      fetchChangeOrdersAction({
        ...pageModel,
        pageNumber: pageModel.page + 1,
        propertyId,
        projectId,
      })
    );
  }, [dispatch, pageModel, projectId, propertyId]);

  useEffect(() => {
    fetchChangeOrders();
  }, [fetchChangeOrders]);

  return (
    <div style={{ width: "100%", height: 500 }}>
      <DataGrid
        data={changeOrdersList.map((r) => ({
          id: r.changeOrderId || r.id,
          ...r,
        }))}
        defineRowId={(row) => {
          return row.changeOrderId || row.id;
        }}
        columns={columns}
        pagination={totalCount > 10}
        page
        totalCount={totalCount}
        paginationModel={pageModel}
        onPaginationChange={(props) => {
          setPageModel(props);
        }}
        disableRowSelectionOnClick
        onRowClick={(p) => onRowClick?.(p.row, "view")}
      />
    </div>
  );
};

export default ListChangeOrders;
